import { AddResidentDigitalPortfolio } from "app/screens/residents/show/AddResidentDigitalPortfolio";

export default function AddResidentDigitalPortfolioPage() {
  return <AddResidentDigitalPortfolio />;
}
